import { PayloadAction } from '@reduxjs/toolkit';
import {
  masterPassListCardReqBodyData,
  masterPassOtpReqBodyData,
  masterPassRegisterReqBodyData,
  masterpassTokenReqBodyData,
  masterPassDeleteCardReqBodyData,
  masterPassCheckAccountReqBodyData,
  masterpassPaymentForMobileReqBodyData,
} from 'Config';
import { MasterPassCardType } from 'Models';
import { BinItem } from 'Models/GetBinListModel';
import { MasterPassTokenEnum } from 'Utils';

export type RequestType =
  | masterPassRegisterReqBodyData
  | masterPassListCardReqBodyData
  | masterPassOtpReqBodyData
  | masterPassDeleteCardReqBodyData
  | masterPassCheckAccountReqBodyData;

export type PayloadDataType = {
  request: {
    data: RequestType;
    type?: MasterPassTokenEnum;
    phoneNumberForMobile?: string;
  };
};

export type MasterPassTokenActionType = {} & PayloadAction<
  (masterpassTokenReqBodyData | masterpassPaymentForMobileReqBodyData) & PayloadDataType
>;

export type tempCard = {
  Name: string;
  Value1: string; // cardNumber used as Value1 for compatibility
  ExpireDate: string;
  Cvv: string;
};

export type CreditCardTransactionsState = {
  token?: string;
  creditCardList?: MasterPassCardType[];
  isConnection?: boolean;
  loading: boolean;
  clientId?: string;
  mmid?: string;
  isHaveAccount: boolean;
  commissionAmount?: number;
  error?: string;
  activeSelectedCreditCard: any;
  loadAmount: number;
  vsPosBelbim3DsecureUrl: any;
  userTempCreditCard?: tempCard;
  tempMasterPassCard?: tempCard;
  is3DSecureModalOpen: boolean;
  isUserAddedCreditCardWithMasterpass: boolean;
  creditCardBinList?: BinItem[];
  activePayment?: string;
  paymentStatus: any;
  masterPassAccountStatus?: string;
};

export const AdditionalParamsStaticData = {
  order_price_type_arr: ['VIRTUAL'],
  order_product_name_arr: ['Belbim Sanal Pos Ödemesi'],
  order_product_code_arr: ['BELBIM1'],
  order_qty_arr: ['1'],
  order_product_info_arr: ['VPOSPURCHASE'],
  order_shipping: '0',
  bill_country_code: 'TR',
  bill_fax: '123213123',
  bill_address: 'bill_address',
  bill_address2: 'bill_address2',
  bill_zip_code: '124214',
  bill_city: 'ISTANBUL',
  bill_state: 'bill_state',
  delivery_company: 'company',
  delivery_address: 'deliveryaddres',
  delivery_address2: 'deliveryaddress2',
  delivery_zip_code: '325325',
  delivery_city: 'deliverycity',
  delivery_state: 'deliverystate',
  delivery_country_code: 'TR',
  number_time: '123',
  owner_time: '1234',
  order_timeout: '123',
  card_program_name: 'MASTERCARD',
  basket_id: '123456',
  vendor_id: '123456',
  buyer_id: '123456',
  identity_number: '123456',
  commission_Rate: '0',
  payment_content: 'payment_content',
  transaction_description: 'transaction_description',
};
